import useBudgetData, { AssignmentBudgetFilters } from "@app/data-hooks/use-budget-data.ts";
import { assignmentBudgetTableDefinition } from "@app/table-definitions/assignment-budget.table-definition.tsx";
import { Button } from "@mui/material";
import { DataTable } from "bi-lib";
import { useState } from "react";
import AssignmentBudgetModal from "./modals/assignments/assignment-budget-modal.tsx";

interface Props {
    catId: number;
    filters: AssignmentBudgetFilters;
    rateType: "billing" | "cost" | "internal";
    assignmentId: number;
}

export default function BudgetTable({ catId, filters, rateType, assignmentId }: Props) {
    const [dialogOpen, setDialogOpen] = useState(false);
    const [entryId, setEntryId] = useState<number>();

    const { entriesSearchList, entryTotals, deleteEntry } = useBudgetData({
        filters: { ...filters, catId },
    });

    return (
        <>
            <AssignmentBudgetModal
                open={dialogOpen}
                onClose={(addNew) => {
                    if (!addNew) {
                        setDialogOpen(false);
                    }
                    setEntryId(undefined);
                }}
                id={entryId}
                assignmentId={assignmentId}
                catId={catId}
                initialStaffId={filters.staffId}
            />
            <DataTable
                rowsPerPageOptions={[5000]}
                label={"Budget"}
                actions={
                    <Button onClick={() => setDialogOpen(true)} variant={"contained"}>
                        Add New
                    </Button>
                }
                columns={assignmentBudgetTableDefinition({
                    catId: catId,
                    onEdit: (id) => {
                        setEntryId(id);
                        setDialogOpen(true);
                    },
                    onDelete: deleteEntry.mutate,
                    rateType,
                    quantityTotal: entryTotals.data?.quantityTotal ?? 0,
                    billingAmountTotal: entryTotals.data?.billingAmountTotal ?? 0,
                    costAmountTotal: entryTotals.data?.costAmountTotal ?? 0,
                    internalAmountTotal: entryTotals.data?.internalAmountTotal ?? 0,
                    rowCount: entriesSearchList.data?.length ?? 0,
                })}
                data={entriesSearchList.data ?? []}
                queryHook={entriesSearchList}
            />
        </>
    );
}
